import { snowtrade } from "../../api";

export const sendGetLeadsRequest = (operatorId) =>
  snowtrade
    .get(`/api/property-operators/${operatorId}/leads`)
    .then((response) => response.data);
